// src/components/StarryBackground.tsx
import React, { useRef, useEffect } from 'react';

export const StarryBackground = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let stars: any[] = [];
    const numStars = 250;
    let animationFrameId: number;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      stars = [];
      for (let i = 0; i < numStars; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          radius: Math.random() * 1.5,
          alpha: Math.random(),
          alphaSpeed: Math.random() * 0.01 + 0.005,
          velocity: { x: (Math.random() - 0.5) * 0.05, y: (Math.random() - 0.5) * 0.05 }
        });
      }
    };

    const animateStars = () => {
      animationFrameId = requestAnimationFrame(animateStars);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(star => {
        star.x += star.velocity.x;
        star.y += star.velocity.y;
        star.alpha += star.alphaSpeed;
        if (star.alpha > 1 || star.alpha < 0) star.alphaSpeed *= -1;
        if (star.x < -star.radius) star.x = canvas.width + star.radius;
        if (star.x > canvas.width + star.radius) star.x = -star.radius;
        if (star.y < -star.radius) star.y = canvas.height + star.radius;
        if (star.y > canvas.height + star.radius) star.y = -star.radius;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = `rgba(255, 255, 255, ${star.alpha})`;
        ctx.fill();
      });
    };

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    animateStars();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []); // Empty dependency array ensures this runs only once

  return (
    <canvas 
      ref={canvasRef} 
      className="fixed top-0 left-0 w-full h-full -z-10"
    />
  );
};
